// extracted by mini-css-extract-plugin
export default {"a0":"_Hr601WqRsbJhJQWSpUX","a1":"_Hr601WqRsbJhJQWSpUX","cls1":"QIdyhPSklqQCgCK_n3se","cls2":"r1dSB3R9Hg3s4HXJuEJC QIdyhPSklqQCgCK_n3se"};